import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './components/app';
import 'bootstrap/dist/css/bootstrap.css';
import './index.css';


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App/>
  </React.StrictMode>
);